import { Backdrop, Box, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { themeColors } from '../../styles';
import AreaSelector from '../../utils/AreaSelector';
import { useArea } from '../../store/area.store';
import useDataArea from '../../hooks/useDataArea';
import { useAuth } from '../../store/auth.store';
import { useNavigate } from 'react-router-dom';
import URLS from '../../enums/route';
import { useFullAccess } from '../../utils/fullAccess';

const Choose = () => {
  const { choosedArea, setChoosedArea } = useArea();
  const { data } = useDataArea();
  const { user } = useAuth();
  const navigate = useNavigate();
  const fullAccess = useFullAccess();

  const allowedAreaCodes = user!?.areaPermissions?.map(p => p.area.code) || [];
  // An impersonating agent sees every area on the account; a sub-user still
  // sees only the areas their areaPermissions grant.
  const filteredData = fullAccess ? data : data?.filter(item => allowedAreaCodes.includes(item.code));

  useEffect(() => {
    if (choosedArea) {
      navigate(URLS.HOME.LINK);
    }
  }, [choosedArea, navigate]);

  const handleChange = (event: SelectChangeEvent<string>) => {
    const selectedValue = event.target.value;
    const selectedArea = filteredData?.find(item => item.code === selectedValue) || null;
    setChoosedArea(selectedArea);
    navigate(URLS.HOME.LINK);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
      <Box>
        <Typography textAlign="center" fontWeight={700} fontSize="20px" color={themeColors.title}>
          נדרש לבחור אתר
        </Typography>
        <Select
          displayEmpty
          value={choosedArea?.code || ''}
          onChange={handleChange}
          renderValue={selected => {
            if (!selected) {
              return <span style={{ color: '#9E9E9E' }}>בחירת אתר</span>;
            }
            const sel = filteredData?.find(item => item.code === selected);
            return sel ? sel.title : '';
          }}
          sx={{
            mt: 2,
            width: 290,
            color: themeColors.title
          }}
          MenuProps={{
            BackdropComponent: props => <Backdrop {...props} sx={{ background: 'none' }} />,
            PaperProps: {
              sx: {
                borderBottomLeftRadius: 2,
                borderBottomRightRadius: 2
              }
            }
          }}
        >
          {filteredData?.map((item, idx) => (
            <MenuItem value={item.code} key={idx}>
              {item.title}
            </MenuItem>
          ))}
        </Select>
        {/* 18% of customers have no area rows at all in Priority. Without this
            the dropdown is simply blank and there is nothing to click, which
            reads as a broken page rather than missing data. */}
        {data && filteredData?.length === 0 && (
          <Typography textAlign="center" fontSize={14} mt={2} color={themeColors.title}>
            לא הוגדרו אתרים ללקוח זה
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default Choose;
